import { env } from "@/config/env";

type LogLevel = "debug" | "info" | "warn" | "error";

const log = (level: LogLevel, ...args: unknown[]) => {
  const prefix = `[${level.toUpperCase()}]`;

  const showInAllModes = env.isLocal || env.isDevelopment;
  const showOnlyWarnAndError = env.isStaging || env.isProduction;

  if (
    (showOnlyWarnAndError && (level === "debug" || level === "info")) ||
    (!showInAllModes && !showOnlyWarnAndError)
  ) {
    return; // Do not log
  }

  switch (level) {
    case "debug":
      console.debug(prefix, ...args);
      break;
    case "info":
      console.info(prefix, ...args);
      break;
    case "warn":
      console.warn(prefix, ...args);
      break;
    case "error":
      console.error(prefix, ...args);
      // TODO: send to Sentry or backend
      break;
  }
};

export const logger = {
  debug: (...args: unknown[]) => log("debug", ...args),
  info: (...args: unknown[]) => log("info", ...args),
  warn: (...args: unknown[]) => log("warn", ...args),
  error: (...args: unknown[]) => log("error", ...args),
};
